import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users } from 'lucide-react';
import { Recipe } from '../../types/recipe';

interface RecipeCardProps {
  recipe: Recipe;
}

export function RecipeCard({ recipe }: RecipeCardProps) {
  const totalTime = recipe.prepTime + recipe.cookingTime;

  return (
    <Link
      to={`/recipes/${recipe.id}`}
      className="group bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow duration-200"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded">
          {recipe.category}
        </span>
        <span
          className={`text-xs font-medium px-2 py-1 rounded ${
            recipe.difficulty === 'easy'
              ? 'bg-green-50 text-green-600'
              : recipe.difficulty === 'medium'
              ? 'bg-yellow-50 text-yellow-600'
              : 'bg-red-50 text-red-600'
          }`}
        >
          {recipe.difficulty}
        </span>
      </div>

      <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-indigo-600 transition-colors">
        {recipe.title}
      </h3>

      <div className="flex items-center text-sm text-gray-500 space-x-4">
        <div className="flex items-center">
          <Clock className="h-4 w-4 mr-1" />
          <span>{totalTime} min</span>
        </div>
        <div className="flex items-center">
          <Users className="h-4 w-4 mr-1" />
          <span>{recipe.servings} servings</span>
        </div>
      </div>

      {recipe.dietaryTags.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1">
          {recipe.dietaryTags.map((tag) => (
            <span
              key={tag}
              className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </Link>
  );
}